import React, {Component} from "react";
import {Form, Input, Button,Select} from "antd";
import {getGame} from '../../../../src/modules/club/action'
import {connect} from "react-redux";
import {withRouter} from "react-router";
import {injectIntl} from "react-intl-context";

const FormItem = Form.Item;
const { Option } = Select;
class ListingFilter extends Component{

    constructor(props) {
        super(props);
        this.state = {

        }
        this.handleSubmit = this.handleSubmit.bind(this);

    }
    componentDidMount() {
        let {getGame} = this.props
        getGame()
    }

    handleSubmit(e) {
        e.preventDefault();
        let _self = this;
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let {onCommit} = _self.props;
                let {exhibitionId,userName,state} = values;
                //console.log('222222222',values)
                onCommit && onCommit(values);

            }
        });
    }
    render() {
        const {getFieldDecorator} = this.props.form;
        return (
            <Form onSubmit={this.handleSubmit} layout="inline">
                <FormItem label="用户展示ID">
                    {getFieldDecorator('exhibitionId', {

                        }
                    )(
                        <Input style={{width: '150px'}} allowClear  />
                    )}
                </FormItem>
                <FormItem label="用户名">
                        {getFieldDecorator('userName', {

                        }
                    )(
                        <Input style={{width: '150px'}} allowClear  />
                    )}
                </FormItem>
                
                <FormItem label="自荐状态:">
                         {getFieldDecorator('state', {
                            initialValue:"",
                        })(
                            <Select style={{width: 120}}>
                                <Option value="">全部</Option>
                                <Option value="REVIEW">未审核</Option>
                                <Option value="SUCCESS">通过</Option>
                                <Option value="FAIL">已驳回</Option>
                            </Select>,
                        )}
                </FormItem>
                <FormItem>
                    <Button type="primary" htmlType="submit" style={{width: '100%'}}>
                        查询
                    </Button>
                </FormItem>

            </Form>
        );
    }
}



const mapStateToProps = (state=>{
        return {
            ...state.viewClub,

        }}
);

const mapDispatchToProps = {
    getGame
};

//const TeamModel = Form.create(TeamModelForm)
export default connect(
    mapStateToProps,
    mapDispatchToProps,
) (Form.create()(withRouter(injectIntl(ListingFilter))));

